import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import SubtleBadge from "components/common/SubtleBadge";

const statusMap = {
  CREDIT_ISSUED: { type: "info", label: "CREDIT ISSUED" },
  PENDING: { type: "warning", label: "PENDING" },
  APPROVED: { type: "success", label: "APPROVED" },
  DENIED: { type: "danger", label: "DENIED" },
  CANCELLED: { type: "secondary", label: "CANCELLED" },
  IN_REVIEW: { type: "secondary", label: "UNDER REVIEW" },
  PAUSED: { type: "secondary", label: "PAUSED" },
  INQUIRED: { type: "info", label: "INQUIRY" },
};

const AdditionalInfoSection = ({
  status,
  createdAt,
  updatedAt,
  description,
  formatDateTime,
}) => {
  const { type, label } = statusMap[status] || {
    type: "secondary",
    label: "Unknown",
  };

  return (
    <Card className="mb-3 custom-shadow">
      <Card.Body>
        <h6 className="fw-bold mb-2">Additional Information</h6>
        <Row>
          <Col>
            <div className="mb-2">
              <label className="form-label text-xxs mb-0">Status</label>
              <SubtleBadge pill bg={type}>
                {label}
              </SubtleBadge>
            </div>
            <div className="mb-2">
              <label className="form-label text-xxs mb-0">Created At</label>
              <h6 className="mb-0 fw-semibold text-sm">
                {formatDateTime(createdAt)}
              </h6>
            </div>
            <div className="mb-2">
              <label className="form-label text-xxs mb-0">Updated At</label>
              <h6 className="mb-0 fw-semibold text-sm">
                {formatDateTime(updatedAt)}
              </h6>
            </div>
            <div className="mb-2">
              <label className="form-label text-xxs mb-0">Description</label>
              <h6 className="mb-0 fw-semibold text-sm">
                {description || "N/A"}
              </h6>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default AdditionalInfoSection;
